module.exports = __webpack_public_path__ + "static/media/success.6e023c60.svg";